// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"b60a476e","253":"62111fae"}[chunkId] + ".chunk.css";
};